import { Dictionary } from '@classes/dictionary/dictionary';
import { BaseClass } from '@classes/base-class';
import { Client } from '@classes/client';
import { Site } from '@classes/site';

export class DictionaryValue extends BaseClass {
  name: string;
  dictionary: Dictionary;
  client: Client;
  temperature?: number | null;
  sites: Site[];
  sortOrder: number;
  isChecked?: boolean;
  selected?: boolean;

  constructor();
  constructor(
    name: string,
    dictionary: Dictionary,
    client: Client,
    sortOrder: number,
  );
  constructor(
    name?: string,
    dictionary?: Dictionary,
    client?: Client,
    sortOrder?: number,
  ) {
    super();

    this.name = this.trim(name);
    this.client = client;
    this.dictionary = dictionary;
    this.sortOrder = sortOrder;
  }

  static fromObject(object: DictionaryValue): DictionaryValue {
    return Object.assign(new DictionaryValue(), {
      ...object,
      client: object.client ? Client.fromObject(object.client) : null,
      dictionary: object.dictionary
        ? Dictionary.fromObject(object.dictionary)
        : null,
      temperature: object.temperature !== undefined ? object.temperature : null,
      sites: object.sites ? object.sites.map((s) => Site.fromObject(s)) : [],
    });
  }

  get display(): string {
    return `${this.name}`;
  }

  doesInclude(value: string): boolean {
    return this.some([this.name], value);
  }
}
